import React, { useState, useEffect, useMemo } from "react";
import { useStore } from "../../store/store";
import { useRequiredMsgs } from "../../store/requiredMsgs";
import { SelectChangeEvent } from "@mui/material";
import {
  sliderImgs,
  handleImages,
  specialAtlanta,
  special,
  normalHandleColorDallas,
  sliderTruthMountColors,
  veronaSliderColor,
  normalHandleColor,
  emtekColors,
  emtekColorsNouvel,
  handleColorPico,
  nonPocketHandles,
  handles,
  handlesPico,
  withKey,
  HandleOption,
  KeyChoiceOption,
} from "./defaults";
import singleDirectionOdds from "../../util/singleDirectionOdds";
import { biFoldDoubleSidedOdds } from "../../util/biFoldDoubleSidedOdds";

function useHandleSelector(hideHandles: boolean) {
  const addToQuote = useStore((state) => state.addToQuote);
  const materialChoice = useStore((state) => state.quote.material);
  const exactConfig = useStore((state) => state.quote.exactConfig);
  const doorType = useStore((state) => state.quote.doorType);
  const sliderPocketing = useStore((state) => state.quote.sliderPocket);
  const chosenConfig = useStore((state) => state.quote.exactConfig);
  const cornerConfigRight = useStore((state) => state.quote.cornerConfigRight);
  const findRequired = useRequiredMsgs((state) => state.findRequired);
  const removeRequired = useRequiredMsgs((state) => state.removeRequired);
  const withHandleChoice = useStore((state) => state.quote.withHandle);
  const withKeyChoice = useStore((state) => state.quote.withKey);
  const handleStyle = useStore((state) => state.quote.handleStyle);
  const finish = useStore((state) => state.quote.handleColor);
  const stilesAndRails = useStore((state) => state.quote.stilesAndRails);
  const bluetoothHandleWifi = useStore(
    (state) => state.quote.bluetoothHandleWifi,
  );
    const secondaryHandleChoice = useStore(
    (state) => state.quote.secondaryHandle,
  );

  const isPocketing =
    sliderPocketing === "With Pocket" ||
    (chosenConfig && chosenConfig.includes("Primary"))
      ? true
      : false;
  const isPico = stilesAndRails?.includes("Pico");
  const isSecondaryHandleAvailable =
    withHandleChoice === "Add Handle Set" &&
    doorType === "Swing" &&
    exactConfig.includes("Pair") &&
    isPico;
  const isBifoldWindow = doorType === "Bi-fold Window";
  const isFixedPanel = doorType === "Fixed Panel";
  const isAluminum = materialChoice === "All Aluminum";
  const isPivot = doorType === "Pivot";

  const [handleColor, setHandleColor] = useState<string[]>([]);
  const [open, setOpen] = useState(false);

  let handleOptions: HandleOption[] = [];
  let keyChoiceOptions: KeyChoiceOption[] = [];
  // const [handleOptions, setHandleOptions] = useState<Object[]>([]);

  const handleImg = useMemo(() => {
    if (!handleStyle) return;

    if (handleStyle === "Smart Lock *") {
      return { label: "", imgLabel: "", colorCategory: "emtek" };
    }

    const images = doorType === "Slider" ? sliderImgs : handleImages;

    return images.find((img) => img.label === handleStyle);
  }, [handleStyle, doorType]);

  const handleWifiChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;
    if (value) {
      addToQuote({ bluetoothHandleWifi: value });
      if (findRequired("Smart Lock Type")) {
        removeRequired("Smart Lock Type");
      }
    } else {
      addToQuote({ bluetoothHandleWifi: "" });
    }
  };

  const handleChange = (event: SelectChangeEvent<string>) => {
    const { value } = event.target;

    if (value) {
      addToQuote({ handleColor: value }, "handleColor");
      if (findRequired("Handle Finish")) removeRequired("Handle Finish");
    } else {
      addToQuote({ handleColor: "" }, "handleColor");
    }
  };

  const handleClose = () => setOpen(false);

  const handleOpen = () => setOpen(true);

  useEffect(() => {
    if (doorType !== "Slider" || !isPocketing) return;
    if (handleStyle === "Verona" || handleStyle === "Dallas") {
      setHandleColor([]);
      addToQuote({
        handleStyle: "",
        handleColor: "",
      });
    }
  }, [isPocketing, doorType]);

  useEffect(() => {
    if (!doorType || !handleStyle) return;

    if (
      doorType === "Slider" &&
      handleStyle === "One Piece Truth (Flush Mount)"
    ) {
      return setHandleColor(sliderTruthMountColors);
    }

    if (handleStyle === "Savannah" || handleStyle === "Toulon") {
      setHandleColor(() =>
        //9/04/2026 - Removed Rustic Umber for Pico units Toulon/Savannah Handle Sets
        stilesAndRails?.startsWith("Pico")
          ? handleColorPico.filter((color) => color !== "Rustic Umber")
          : handleColorPico,
      );
    } else if (handleStyle === "Dallas") {
      setHandleColor(normalHandleColorDallas);
    } else if (handleStyle === "Verona") {
      doorType !== "Sliders"
        ? setHandleColor(normalHandleColor)
        : setHandleColor(veronaSliderColor);
    } else {
      if (
        handleImg &&
        "colorCategory" in handleImg &&
        handleImg.colorCategory
      ) {
        const colorObj = {
          "special atlanta": specialAtlanta,
          special: special,
          emtek: emtekColors,
          "emtek nouvel": emtekColorsNouvel,
        };
        const colorCategory = handleImg.colorCategory as string;

        setHandleColor(colorObj[colorCategory]);
      }
    }
  }, [doorType, handleStyle, stilesAndRails]);

  useEffect(() => {
    if (
      isBifoldWindow ||
      isFixedPanel ||
      isAluminum ||
      isPivot ||
      hideHandles ||
      withHandleChoice === "No Handle Set"
    ) {
      addToQuote({
        secondaryHandle: "",
        handleStyle: "",
        handleColor: "",
        withKey: "",
      });
    }
  }, [doorType, exactConfig, withHandleChoice]);

  const handleClickWithHandle = (label: string) => {
    const checked = label === withHandleChoice;

    if (checked) {
      addToQuote({ withHandle: "" });
    } else {
      addToQuote({ withHandle: label });
      if (findRequired("Handle Set")) removeRequired("Handle Set");
    }
  };

  const handleClickSecondaryHandle = (label: string) => {
    addToQuote({
      secondaryHandle: label === secondaryHandleChoice ? "" : label,
    });
    if (findRequired("Secondary Handle")) removeRequired("Secondary Handle");
  };

  const handleClickWithKey = (label: string) => {
    const checked = label === withKeyChoice;

    if (checked) {
      addToQuote({ withKey: "" });
    } else {
      addToQuote({ withKey: label });

      if (findRequired("Handle Key option")) {
        removeRequired("Handle Key option");
      }
    }
  };

  const handleClickHandleStyle = (label: string) => {
    if (!label) return;

    const checked = label === handleStyle;

    if (checked) {
      addToQuote({ handleStyle: "" }, "handleStyle");
    } else {
      const colorCategory =
        handleImages.find((itm) => itm.label === label)?.colorCategory || "";

      if (
        handleImg &&
        "colorCategory" in handleImg &&
        colorCategory !== handleImg.colorCategory
      ) {
        addToQuote({ handleColor: "" }, "handleColor");
      }

      let update = { handleStyle: label };

      if (label === "Smart Lock *") {
        if (stilesAndRails?.startsWith("Pico")) {
          update["stilesAndRails"] = "";
          update["stileCategory"] = "";
        }
      }

      addToQuote(update, "handleStyle");
      if (findRequired("Handle Style")) {
        removeRequired("Handle Style");
      }
    }
  };

  const hasBluetoothHandle =
    withHandleChoice === "Add Handle Set" && handleStyle === "Smart Lock *"
      ? true
      : false;

  const singleSidedOdd = !doorType?.includes("Bi-fold")
    ? false
    : (doorType?.includes("Corner") &&
          singleDirectionOdds.includes(chosenConfig)) ||
        singleDirectionOdds.includes(cornerConfigRight || "")
      ? true
      : singleDirectionOdds.includes(chosenConfig);

  // const handleOptions =
  //   doorType === "Slider" && isPocketing
  //     ? nonPocketHandles.filter((itm) => itm.label?.includes("Truth"))
  //     : doorType === "Slider"
  //       ? nonPocketHandles
  //       : isPico
  //         ? handlesPico
  //         : singleSidedOdd || doorType === "Swing"
  //           ? handles
  //           : handles.filter(
  //               (itm) => itm.label !== "Toulon" && itm.label !== "Savannah",
  //             );

  // const handleOptions =
  // doorType === "Slider" && isPocketing
  //   ? nonPocketHandles.filter((itm) => itm.label?.includes("Truth"))
  //   : doorType === "Slider"
  //     ? nonPocketHandles
  //     : isPico
  //       ? handlesPico
  //       : handles

  const filterHandleOptions = () => {
    if (doorType === "Slider" && isPocketing) {
      return nonPocketHandles.filter((itm) => itm.label?.includes("Truth"));
    } else if (doorType === "Slider") {
      return nonPocketHandles;
    } else if (isPico) {
      return handlesPico;
    } else {
      return handles;
    }
  };

  handleOptions = filterHandleOptions();

  const filterKeyChoiceOptions = () => {
    //removing no key options when a bi fold double sided odd config or pair swing that is not a pico door and has a toulon or savannah handle selected
    if (
      !isPico &&
      (handleStyle === "Toulon" || handleStyle === "Savannah") &&
      (biFoldDoubleSidedOdds.includes(exactConfig) ||
        exactConfig.includes("Pair"))
    ) {
      //auto select exterior key
      addToQuote({ withKey: "Exterior Key" });
      return withKey.filter((item) => item.label === "Exterior Key");
    } else {
      return withKey;
    }
  };

  keyChoiceOptions = filterKeyChoiceOptions();

  // const handleWithKeyOptions = (doubleSidedOdds.includes(chosenConfig) || chosenConfig.includes("Pair")) && withHandle == "" ? withKey.filter((item) => item.label === "With Key") : "With Key";

  return {
    handleImg,
    handleClickHandleStyle,
    handleClickWithKey,
    handleClickWithHandle,
    handleClose,
    handleOpen,
    handleChange,
    handleColor,
    finish,
    open,
    withHandleChoice,
    withKeyChoice,
    keyChoiceOptions,
    handleStyle,
    doorType,
    bluetoothHandleWifi,
    handleWifiChange,
    stilesAndRails,
    hasBluetoothHandle,
    singleSidedOdd,
    handleOptions,
    isPico,
    secondaryHandleChoice,
    handleClickSecondaryHandle,
    isSecondaryHandleAvailable,
  };
}

export default useHandleSelector;
